import { StaffItemCombinedProps } from './types';

const usePresenter = (props: StaffItemCombinedProps): StaffItemCombinedProps => {
  return props;
};

export default usePresenter;
